module.exports = __webpack_public_path__ + "static/media/lottery-after.8cab207f.png";